import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api'
import Prettyfier from 'components/Prettyfier';
import ScrollToTopOnMount from '../ScrollToTopOnMount';

import './Legal.css';

// import Immutable from 'immutable';

import {
  fetchData,
  getDataLegal,
  getLoadingError,
} from '../../ducks/asyncFetcher';


const AF_KEY = 'legal';

class Legal extends Component {
  // constructor(props) {
  //   super(props);
  // }
  componentDidMount() {

    this.props.onMount();

  }
  render() {

    const { $$data } = this.props;

    const $$legal = $$data !== undefined ? $$data.get('legal').get(0).get('items').get(0) : undefined;

    return (
      <div id="legal" className="Legal">
        <Choose>
          <When condition={$$legal !== undefined}>
            <ScrollToTopOnMount/>
            <div className="legalWrapper">
            <h1>{$$legal.get('title')}</h1>
            <div className="content"><Prettyfier text={$$legal.get('content')} transformBullets={false}/></div>
            </div>
        </When>
        <Otherwise>
          <div>LOADING !!</div>
        </Otherwise>
      </Choose>
    </div>

  );
}
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataLegal(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {dispatch(fetchData( {key: AF_KEY, fetchUrl: config.legal}))}
  };
}
// export default Mission;
export default connect(mapStateToProps, mapDispatchToProps)(Legal);



// WEBPACK FOOTER //
// ./src/components/Legal/Legal.jsx